export default __webpack_public_path__ + "static/tv-5-cd5afb52402614e0294a0f7eee63d374.png";